export default __webpack_public_path__ + "locales/ro/ConnectDialog.json?hash=7b8467b68c4dbcd8b1f329818db571bf";